import {
  MsMarketType,
  MsSubDomainType,
  NavLinkInterface,
} from "@ms/gatsby-site/src/types/navigation";

// Export from global file to remove duplication
export { countries } from "@ms/gatsby-site/src/config/global";

export const currentMsMarket: MsMarketType = "us";

export const currentMsSubDomain: MsSubDomainType = "www";

export const currentMsCurrencyCode = "USD";

// needs trailing slash since blog home page is at '/blogs' + '/'
export const blogLink: NavLinkInterface = { to: "/blogs/", label: "Blog" };
